let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page003_game2/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    // negative: 'games/page003_game1/audio/false.mp3',
    positive: 'games/page003_game1/audio/6_bear.mp3',
    click: 'games/page003_game1/audio/click.mp3',
    icon: {
      on: 'games/page003_game1/img/audioOn.png',
      off: 'games/page003_game1/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 165,
    height: 305,
  },
  layoutItems: [
    {
      pos: {
        x: 96,
        y: 96,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 875,
        y: 147,
      },
    },
    {
      pos: {
        x: 1370,
        y: 147,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page003_game1/audio/6_bear.mp3',
          correct: {
            image: {
              src: 'games/page003_game2/img/g_2.png',
            },
            width: 417,
            height: 580,
            correctItems: {
              images: [
                {
                  src: 'games/page003_game2/img/g_2_tick.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 417,
                  height: 580,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page003_game2/img/b_2.png',
            },
            width: 417,
            height: 580,
            incorrectItems: {
              images: [
                {
                  src: 'games/page003_game2/img/b_2_cross.png',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 417,
                  height: 580,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
};

export default elements;
